// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"657090b1","42":"78cd16a6","453":"f6b27ae4","616":"8b21a9ad","662":"660f670e"}[chunkId] + ".chunk.js";
};